import { render, staticRenderFns } from "./productLabel.vue?vue&type=template&id=06020c43&scoped=true&"
import script from "./productLabel.vue?vue&type=script&lang=js&"
export * from "./productLabel.vue?vue&type=script&lang=js&"
import style0 from "./productLabel.vue?vue&type=style&index=0&id=06020c43&prod&lang=scss&"
import style1 from "./productLabel.vue?vue&type=style&index=1&id=06020c43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06020c43",
  null
  
)

export default component.exports